import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import React from 'react';
import Logo from './CityDao_Green-logo.svg';

const CityDAOLogo = (props: SvgIconProps) => <SvgIcon {...props} component={Logo} viewBox="0 0 169.827 170.397" />;
export default CityDAOLogo;
